import styled from '@emotion/styled';

import { SVGIcon } from '../Icon/SVGIcon';

const StyledSVGIcon = styled(SVGIcon)({
  // The svg sits inline on a text line of the wrapper. An inherited line height makes that line taller than the icon
  // and pushes the icon down, e.g. in buttons
  lineHeight: 0,

  '& svg': {
    width: '100%',
    height: '100%',
  },

  [`& svg path:not([fill='none']),
    & svg circle:not([fill='none']),
    & svg rect:not([fill='none']),
    & svg polygon:not([fill='none']),
    & svg line:not([fill='none']),
    & svg polyline:not([fill='none'])`]: {
    fill: 'currentColor',
  },

  "& svg [stroke]:not([stroke='none'])": {
    stroke: 'currentColor',
  },
});

export const S = {
  StyledSVGIcon,
} as const;
